interface ChooseLanguageDialogInterface {
  status: boolean
}

export interface SystemStateInterface {
  chooseLanguageDialog: ChooseLanguageDialogInterface
}

function state(): SystemStateInterface {
  return {
    chooseLanguageDialog: {
      status: !Boolean(localStorage.getItem('locale')),
    },
  }
}

export default state
